
import {Component, Vue, Watch} from 'vue-property-decorator'
import UserService from '@/service/user/UserService'
// eslint-disable-next-line no-unused-vars
import DashboardServiceInfo from '@/model/user/DashboardServiceInfo'
// eslint-disable-next-line no-unused-vars
import DashboardModuleInfo from '@/model/user/DashboardModuleInfo'
import LoginService from '@/service/user/LoginService'
import UserInfo from '@/model/modules/UserInfo'
import UserInfoService from '@/service/modules/UserInfoService'

@Component
export default class MainMenu extends Vue {
  dashboardModules: DashboardServiceInfo[] = []
  menuPanelData: number = 0
  currentUserInfo: UserInfo = new UserInfo()

  mounted() {
    UserService.getDashBoardBaseInfo()
      .then((dashboardModules: DashboardServiceInfo[]) => {
        this.dashboardModules = dashboardModules
        UserService.setSelectedDashboardModule(dashboardModules[0].dashBoardModules[0])
      })
    this.refreshUserInfo()
  }

  @Watch('$route')
  refreshUserInfo() {
    UserInfoService.getCurrentUserInfo()
      .then((user: UserInfo) => {
        this.currentUserInfo = user
      })
  }

  onMenuClicked(dashboardModule: DashboardModuleInfo) {
    UserService.setSelectedDashboardModule(dashboardModule)
  }

  logout() {
    this.$confirm('您确认要退出登录吗?', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    }).then(() => {
      LoginService.logout()
    })
  }
}
